import { render, staticRenderFns } from "./GroupCombo.vue?vue&type=template&id=745dbb86&"
import script from "./GroupCombo.vue?vue&type=script&lang=js&"
export * from "./GroupCombo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports